// Mitigates "Blocked aria-hidden" when focus stays on a button/page element
// while Modal/Dialog/DatePicker calendar opens and sets aria-hidden on root
import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Modal(theme: Theme) {
  return {
    MuiModal: {
      defaultProps: {
        disableEnforceFocus: true,
        disableRestoreFocus: true,
      },
    },
  };
}
